import { useEffect, useState } from "react";
import { Lock } from "lucide-react";
import { api } from "@/lib/api";
import Countdown from "@/components/Countdown";

/**
 * Blokada formularzy zamówień do momentu startu sprzedaży.
 * - Pobiera /api/sales-status i sprawdza czy sprzedaż jest zablokowana
 * - Jeśli TAK -> pokazuje ładny komunikat + odliczanie (zamiast dzieci)
 * - Jeśli NIE -> renderuje dzieci (formularz)
 */
export default function SalesLockGate({ children, title = "Zamówienia niedostępne" }) {
  const [status, setStatus] = useState(null);   // {locked, target_at}
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    let alive = true;
    api.get("/sales-status")
      .then((r) => { if (alive) { setStatus(r.data); setChecked(true); } })
      .catch(() => { if (alive) { setStatus({ locked: false }); setChecked(true); } });
    return () => { alive = false; };
  }, []);

  // Automatyczne odblokowanie gdy czas upłynie (bez potrzeby przeładowania).
  // Po dobiciu do zera dodatkowo przepytujemy backend by mieć pewność że serwer
  // też uznał sprzedaż za odblokowaną (a nie tylko lokalny zegar przeglądarki).
  useEffect(() => {
    if (!status?.locked || !status?.target_at) return;
    const targetMs = new Date(status.target_at).getTime();
    const delay = targetMs - Date.now();
    if (delay <= 0 || delay > 2147483647) return;
    const id = setTimeout(async () => {
      // Zaczekaj 2 sekundy po dojściu do 0, potem re-sprawdź backend
      try {
        const r = await api.get("/sales-status");
        setStatus(r.data);
      } catch {
        setStatus((s) => ({ ...s, locked: false }));
      }
    }, delay + 2000);
    return () => clearTimeout(id);
  }, [status]);

  if (!checked) return null;                     // krótki flash, nie renderuj nic
  if (!status?.locked) return <>{children}</>;   // sprzedaż otwarta -> pokaż formularz

  return (
    <div data-testid="sales-lock-notice" className="max-w-3xl mx-auto mt-10">
      <div className="rm-card p-8 md:p-12 text-center">
        <div className="w-16 h-16 rounded-full bg-[#dc2626]/10 border-2 border-[#dc2626] flex items-center justify-center mx-auto mb-6">
          <Lock size={28} className="text-[#dc2626]" />
        </div>
        <h2 className="font-display text-3xl md:text-4xl font-black text-[#0f172a]">
          {title}
        </h2>
        <p className="text-slate-600 mt-3 max-w-lg mx-auto">
          Sprzedaż jeszcze nie wystartowała. Wróć w dniu premiery — formularz odblokuje się automatycznie.
        </p>
        <div className="mt-6">
          <Countdown
            label="Do startu pozostało"
            targetAt={status.target_at}
            enabled={true}
          />
        </div>
      </div>
    </div>
  );
}
